import { TELEMETRY_KEY, encryptEnvelope, importTelemetryKey } from '@smart-link/shared';
import { getBeaconKey } from './config';

let keyPromise: Promise<CryptoKey | null> | null = null;

function loadKey(): Promise<CryptoKey | null> {
  if (!keyPromise) {
    const raw = getBeaconKey() || TELEMETRY_KEY;
    const hasCrypto = typeof crypto !== 'undefined' && !!crypto.subtle;
    const load =
      raw && hasCrypto ? importTelemetryKey(raw).catch(() => null) : Promise.resolve(null);
    // importKey 也可能在恶劣 webview 里挂起;超时缓存 null(全程回落明文),
    // 避免后续每次 sealBody 都重新等待挂死的 promise。
    keyPromise = Promise.race([
      load,
      new Promise<CryptoKey | null>((resolve) => {
        setTimeout(() => resolve(null), 1500);
      }),
    ]);
  }
  return keyPromise;
}

/**
 * Seal a telemetry payload into the binary AES-GCM envelope, returning bytes
 * ready for sendBeacon / fetch. Returns null when Web Crypto is unavailable
 * (ancient browser); callers then send plaintext, which the worker still accepts.
 */
export async function sealBody(payload: unknown): Promise<Uint8Array<ArrayBuffer> | null> {
  try {
    // crypto.subtle 在某些 in-app webview(如 iOS TikTok)里可能挂起 —— 存在(hasCrypto
    // 为真)但 importKey/encrypt 永不 resolve,把 verify 卡死在 "Checking..."。
    // 超时回落 null → 调用方改发明文(worker 的 decryptedJson 接受明文),verify 继续。
    return await Promise.race([
      (async (): Promise<Uint8Array<ArrayBuffer> | null> => {
        const key = await loadKey();
        if (!key) return null;
        return await encryptEnvelope(key, JSON.stringify(payload));
      })(),
      new Promise<null>((resolve) => {
        setTimeout(() => resolve(null), 1500);
      }),
    ]);
  } catch {
    return null;
  }
}
